// extracted by mini-css-extract-plugin
module.exports = {"popper":"main-debug_popper_1Vc3h"};